export default "__VITE_ASSET__CTUTH8pJ__"